import React from 'react';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';

import Typography from '@ts-core/components/Typography';
import Button from '@ts-core/components/Button';

import { PracticeExercise, PracticeSubject } from '../../types';

export interface AvailableExercisesListProps {
  practiceSubjects: PracticeSubject[];

  onSelectExercise: (exercise: PracticeExercise) => void;
  onSelectSubjectExercises: (subject: PracticeSubject) => void;
  isExerciseSelected: (exercise: PracticeExercise) => boolean;
}

const AvailableExercisesList = (props: AvailableExercisesListProps) => {
  const intl = useIntl();
  const { isExerciseSelected, onSelectExercise, onSelectSubjectExercises, practiceSubjects } = props;

  const handleSelectSubject = (subject: PracticeSubject) => () => {
    onSelectSubjectExercises(subject);
  };

  const handleSelectExercise = (exercise: PracticeExercise) => () => {
    onSelectExercise(exercise);
  };

  return (
    <Box height="100%" sx={{ overflowY: 'auto' }}>
      <Typography sx={{ mb: 2 }} variant="subtitle2">
        {intl.formatMessage({ id: 'practiceSession.availableExercises' })}
      </Typography>

      <Paper>
        {practiceSubjects.map((subject, index) => (
          <List key={index} sx={{ py: 0 }}>
            {index !== 0 && <Divider />}
            <ListItem sx={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }} dense divider>
              <ListItemText
                primary={subject.path}
                secondary={intl.formatMessage({ id: 'practiceSession.exercisesCount' }, { count: subject.exercises.length })}
              />
              <div>
                <Button size="small" onClick={handleSelectSubject(subject)}>
                  {intl.formatMessage({ id: 'practiceSession.practiceAll' })}
                </Button>
              </div>
            </ListItem>
            {subject.exercises.map((exercise) => (
              <ListItem dense key={exercise._id} button onClick={handleSelectExercise(exercise)}>
                <Checkbox disableRipple checked={isExerciseSelected(exercise)} />
                <ListItemText primary={exercise.code} sx={{ p: 0 }} />
              </ListItem>
            ))}
          </List>
        ))}
      </Paper>
    </Box>
  );
};

export default AvailableExercisesList;
